import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
(function () {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
  script.async = true;
  document.head.appendChild(script);
})();
(function (h: any, o: any, t: any, j: any) {
  h.hj = h.hj || function () {
    ;
    (h.hj.q = h.hj.q || []).push(arguments);
  };
  h._hjSettings = {
    hjid: 6685974,
    hjsv: 6
  };
  const a = o.getElementsByTagName('head')[0];
  const r = o.createElement('script');
  r.async = 1;
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
  a.appendChild(r);
})(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
// Meta Pixel is now loaded via MetaPixel component in AppRouter
render(<AppRouter data-id="element-524" />, document.getElementById('root'));